import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material'
import { Logger } from '@wolfdanepug/common-react'
import { useEffect } from 'react'
import useSegmentConfig from '../lib/useSegmentConfig'

export interface SegmentProps {
	name?: string
	path?: string
	data?: any
}

export default function Segment({ name, path, data = {} }: SegmentProps) {
	useEffect(() => {
		Logger.log('[Segment]', { name, path, data })
	}, [name, path, data])

	const {
		state,
		segmentName,
		sectionIndex,
		segmentIndex,
		setCanStepForward,
		completed,
		component: Component,
		...rest
	}: any = useSegmentConfig({ name, path, data })
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	return (
		<Component
			data={data}
			state={state}
			segmentName={segmentName}
			sectionIndex={sectionIndex}
			segmentIndex={segmentIndex}
			selectedIndex={data?.activeDogContext || 0}
			setCanStepForward={setCanStepForward}
			completed={completed}
			isMobile={isMobile}
			{...rest}
		/>
	)
}
